import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {NavbarNavComponent, NavItemComponent} from './navbar.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [NavItemComponent, NavbarNavComponent],
  exports: [NavItemComponent, NavbarNavComponent]
})
export class NavbarModule { }
